<template>
  <button
    type="button"
    aria-label="chats-button"
    class="chats-btn"
    :class="[size ? 'chats-btn--' + size : '', isOpen ? 'rotate' : '']"
    @click="toggleBtn"
    :style="[!isOpen ?
      {
        'background-image': `url(${mainIcon.icon})`,
        'background-color': mainIcon.background
      } :
      {
        'background-image': `url(${mainIcon.closeIcon})`,
        'background-color': mainIcon.closeBackground
      }
    ]"
  >
  </button>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ChatsBtn',
  props: {
    size: {
      type: String,
      default: 'large'
    }
  },
  methods: {
    ...mapActions(['SET_CHATS_LIST_STATUS']),
    toggleBtn: function () {
      this.SET_CHATS_LIST_STATUS(!this.isOpen)
    }
  },
  computed: {
    ...mapState({
      isOpen: state => state.chats.isOpen,
      mainIcon: state => state.chats.mainIcon
    })
  }
}
</script>

<style scoped lang="sass">

.chats-btn
  position: absolute
  top: 0
  left: 0
  bottom: 0
  right: 0
  padding: 0
  border: none
  border-radius: 50%
  margin: auto
  box-shadow: 0 0 30px rgba(116,116,116,.33)
  background-position: center
  background-repeat: no-repeat
  background-size: 50%
  z-index: 11
  outline: none
  transition: .2s

  &--small
    width: 40px
    height: 40px

    +mmin($tablet--hor)
      width: 60px
      height: 60px

  &--medium
    width: 50px
    height: 50px

  &--large
    width: 60px
    height: 60px

  &:focus
    box-shadow: 0 0 30px rgba(116,116,116,.33)

  &:before,
  &:after
    content: ''
    display: block
    position: absolute
    border-radius: 50%
    border: 1px solid #ff2f00
    left: -20px
    right: -20px
    top: -20px
    bottom: -20px
    animation: animate 3s linear infinite
    animation-delay: 2s
    opacity: 0
    backface-visibility: hidden

  &:after
    animation-delay: 2.2s

.chats-btn.rotate
  &:before,
  &:after
    display: none

@keyframes animate
  0%
    transform: scale(0.4)
    opacity: 0
  15%
    opacity: 1
  30%
    transform: scale(0.8)
    opacity: 0
  100%
    transform: scale(0.6)
    opacity: 0

.rotate
  transform: rotate(90deg)
</style>
